import {
    ExtendedFieldId,
    Validator,
    ExtendedErrorId,
    setCustomValidator,
    FieldContent,
} from '@sheerid/jslib';

export const planOfUseValidator = () => {
    const planOfUse: ExtendedFieldId = 'plan-of-use';

    const getPlanOfUseValidationError: Validator = (value: FieldContent): ExtendedErrorId => {
        const invalidError: ExtendedErrorId = 'invalidPlanOfUse';

        if (!value) {
            return invalidError;
        }

        return;
    };

    setCustomValidator(planOfUse, getPlanOfUseValidationError);
};
